import React from "react";
import { useFormikContext } from "formik";
import Button from "~/components/Button";
import LoadingSpinner from "~/components/LoadingSpinner";
import "./SubmitButton.css";

type SubmitButtonProps = {
  readonly label: string;
  readonly disabled?: boolean;
};

function SubmitButton({ label, disabled }: SubmitButtonProps) {
  const { isSubmitting } = useFormikContext();
  return (
    <div className="submit-button-row">
      <Button
        type="submit"
        disabled={isSubmitting || disabled}
        colour="red"
        variant="solid"
        size="large"
      >
        {isSubmitting ? <LoadingSpinner /> : label}
      </Button>
    </div>
  );
}

export default SubmitButton;
